/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Moderationcolumnreporter2Inputs */

const en_moderationcolumnreporter2 = /** @type {(inputs: Moderationcolumnreporter2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Reporter`)
};

const de_moderationcolumnreporter2 = /** @type {(inputs: Moderationcolumnreporter2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Meldende Person`)
};

/**
* | output |
* | --- |
* | "Reporter" |
*
* @param {Moderationcolumnreporter2Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const moderationcolumnreporter2 = /** @type {((inputs?: Moderationcolumnreporter2Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Moderationcolumnreporter2Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_moderationcolumnreporter2(inputs)
	return de_moderationcolumnreporter2(inputs)
});
export { moderationcolumnreporter2 as "moderationColumnReporter" }